export function allValuesExist<T>(arr: T[]): boolean {
  return arr.every((value: T): value is NonNullable<T> => value !== null && value !== undefined);
}

/**
 * Simple blockchain address validators
 */

/**
 * Validates if a string is a valid Ethereum address.
 * Ethereum addresses are 0x-prefixed 40-character hex strings.
 */
export function isValidEthereumAddress(address: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
}

/**
 * Validates if a string is a valid Solana address.
 * Solana addresses are 32-44 character base58 strings.
 */
export function isValidSolanaAddress(address: string): boolean {
  return /^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(address);
}

/**
 * Validates if a string is a valid Sui address.
 * Sui addresses are 0x-prefixed 64-character hex strings.
 */
export function isValidSuiAddress(address: string): boolean {
  return /^0x[a-fA-F0-9]{64}$/.test(address);
}

/**
 * Validates if a string is a valid Injective address.
 * Injective uses bech32-encoded addresses with the `inj` HRP, e.g. `inj1...`.
 */
export function isValidInjectiveAddress(address: string): boolean {
  return /^inj1[ac-hj-np-z02-9]{38}$/.test(address);
}

/**
 * isEmptyObject
 * @returns boolean
 * @example
 * !isEmptyObject({foo: 'bar'}) => true
 * isEmptyObject({}) => true
 */
export function isEmptyObject(obj: Record<string, unknown>): boolean {
  return Object.keys(obj).length === 0;
}

/**
 * isArray
 * @returns boolean
 * @example
 * isArray([0, 1]) => true
 * isArray('hi') => false
 */
export const isArray = (arr: unknown): arr is [] => Array.isArray(arr);
